package dev.moetz.sslcertificatetool.design

import dev.moetz.materialize.mFooter
import react.ChildrenBuilder

fun ChildrenBuilder.mFooter() {
    mFooter(
        socialLink = "https://diamir.io",
        pageName = "SSL Certificate Tool",
        gitUrl = "https://gitlab.diamir.tech/kotlin/ssl-certificate-tool",
        isOpenSource = false,
    )
}
